import React, { useState, useEffect, useRef } from 'react';
import { getTeamLogoPaths } from '../utils/teamUtils';

// Кэш для проверенных путей к логотипам
const logoCache = new Map();

// Функция для очистки кэша (для отладки)
export const clearLogoCache = () => {
  logoCache.clear();
};

const TeamLogo = ({ teamName, className = "w-10 h-10", alt, width = 40, height = 40 }) => {
  const [currentSrc, setCurrentSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const pathIndexRef = useRef(0);
  const logoPathsRef = useRef([]);

  useEffect(() => {
    // Сброс состояния при смене команды
    setHasError(false);
    pathIndexRef.current = 0;
    
    // Проверяем кэш
    if (logoCache.has(teamName)) {
      const cachedPath = logoCache.get(teamName);
      setCurrentSrc(cachedPath);
      return;
    }
    
    // Получаем пути для поиска
    logoPathsRef.current = getTeamLogoPaths(teamName);
    
    // Начинаем с первого пути
    if (logoPathsRef.current.length > 0) {
      setCurrentSrc(logoPathsRef.current[0]);
    } else {
      setCurrentSrc('/teams/default.png');
    }
  }, [teamName]);

  const handleError = () => {
    const nextIndex = pathIndexRef.current + 1;
    
    if (nextIndex < logoPathsRef.current.length) {
      pathIndexRef.current = nextIndex;
      setCurrentSrc(logoPathsRef.current[nextIndex]);
    } else {
      // Все пути проверены, используем дефолтный
      setHasError(true);
      setCurrentSrc('/teams/default.png');
    }
  };

  const handleLoad = () => {
    setIsLoading(false);
    setHasError(false);
    // Кэшируем только успешные загрузки (не default)
    if (currentSrc && !currentSrc.includes('default.png')) {
      logoCache.set(teamName, currentSrc);
    }
  };

  return (
    <div className={`${className} relative flex items-center justify-center`}>
      {isLoading && !hasError && (
        <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse" />
      )}
      {currentSrc && (
        <img
          src={currentSrc}
          alt={alt || `${teamName} logo`}
          className={`${className} object-contain rounded-full shadow-md transition-opacity duration-200`}
          width={width}
          height={height}
          onError={handleError}
          onLoad={handleLoad}
          loading="lazy"
        />
      )}
      {hasError && (
        <div className={`${className} bg-gray-300 dark:bg-gray-600 rounded-full flex items-center justify-center text-gray-500 dark:text-gray-400 text-xs font-bold`}>
          {teamName.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  );
};

export default TeamLogo; 